import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-indigo-700 text-white py-8">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start md:items-center">
        
        {/* Brand Info and Description */}
        <div className="mb-4 md:mb-0">
          <Link to="/" className="text-xl font-bold">GetAHomePrice.com</Link>
          <p className="text-sm text-gray-300 mt-1">
            Helping homeowners get the best deal with competitive offers on homes.
          </p>
        </div>

        {/* Footer Links */}
        <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6">
          <Link to="/about" className="text-sm hover:text-gray-300 transition">About Us</Link>
          <Link to="/services" className="text-sm hover:text-gray-300 transition">Services</Link>
          <Link to="/contact" className="text-sm hover:text-gray-300 transition">Contact</Link>
          <Link to="/tos" className="text-sm hover:text-gray-300 transition">Terms of Service</Link>
          <Link to="/privacy-policy" className="text-sm hover:text-gray-300 transition">Privacy Policy</Link>
        </div>

        {/* Contact Information */}
        <div className="mt-4 md:mt-0">
          <p className="text-sm text-gray-300">Email: info@yourbrand.com</p>
          <p className="text-sm text-gray-300">Phone: (123) 456-7890</p>
        </div>
      </div>

      {/* Bottom Section with Copyright */}
      <div className="container mx-auto text-center text-gray-400 mt-6">
        <p>© {new Date().getFullYear()} GetAHomePrice.com. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;

